import { EditOutlined, PrinterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import {
  Button,
  Input,
  Space,
  message,
  Tag,
  Breadcrumb,
  Flex,
  Row,
  Col,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDebounce from "../hooks/useDebounce";
import WelcomeTopbar from "../components/common/header/WelcomeTopbar";
import { useAssetDetailsByTag } from "../api/hooks/asset";
import { DATE_TIME_FORMAT } from "../utils/date";
import LogoLoader from "../components/common/LogoLoader";
import { downloadBolPdf } from "./processes/shipments/ShipmentsPage";

function SearchTagPage() {
  const navigate = useNavigate();
  const [tagId, setTagId] = useState();
  const debouncedTagId = useDebounce(tagId, 500);
  const [details, setDetails] = useState([]);
  const [downLoadingId, setDownLoadingId] = useState();

  const { data: assetDetailsRes, isLoading: isLoadingAssetDetails } =
    useAssetDetailsByTag({ tagId: debouncedTagId });

  useEffect(() => {
    if (!assetDetailsRes) return;

    const {
      asset = {},
      lastAssociatedBol = {},
      lastAssetEvents = [],
    } = assetDetailsRes;

    console.log("asset?.tag?.name", asset?.tag?.name);

    setDetails([
      { title: "TAG ID", value: asset?.tag?.upc },
      { title: "PO Number", value: lastAssociatedBol?.order?.poNumber },
      // { title: "Location", value: "" },
      { title: "Status", value: asset?.lastState },
      { title: "BOL Number", value: lastAssociatedBol?.referenceId },
      { title: "Customer", value: lastAssociatedBol?.order?.customer?.name },
      {
        title: "Last Update",
        value: dayjs(lastAssetEvents?.[0]?.updatedAt).format(DATE_TIME_FORMAT),
      },
      { title: "Product", value: asset?.product?.name },
      { title: "Tag Name", value: asset?.tag?.name },
    ]);
  }, [assetDetailsRes]);

  return (
    <div className="flex flex-col">
      <WelcomeTopbar />
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-6 pb-6">
          <div className="flex min-h-14 justify-between rounded-t-xl bg-[#D1DFFF] px-6 py-3">
            <Breadcrumb
              className="bg-[#D1DFFF]"
              items={[
                {
                  title: <div className="text-lg">Search</div>,
                },
              ]}
            />
          </div>
          <div className="flex flex-col gap-6 px-6">
            <div className="flex items-end justify-between gap-6">
              <div>
                <Input.Search
                  placeholder="TAG ID"
                  value={tagId}
                  onChange={(e) => {
                    setTagId(e.target.value);
                  }}
                  className="min-w-64"
                />
              </div>
            </div>
          </div>
          <div className="max-w-3xl p-5">
            {isLoadingAssetDetails && <LogoLoader />}
            {assetDetailsRes && (
              <Flex className="flex-col gap-1">
                {/* {details?.map(({ title = "", value }) => {
                return (
                  <Row gutter={12} className="flex-grow" key={title}>
                    <Col span={8} className="font-medium">
                      {title}
                    </Col>
                    <Col span={16}>{value ?? "-"}</Col>
                  </Row>
                );
              })} */}
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    TAG ID
                  </Col>
                  <Col span={16}>{assetDetailsRes?.asset?.tag?.upc ?? "-"}</Col>
                </Row>
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    PO Number
                  </Col>
                  <Col span={16}>
                    {assetDetailsRes?.lastAssociatedBol?.order?.poNumber ?? "-"}
                  </Col>
                </Row>
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    Status
                  </Col>
                  <Col span={16}>
                    {assetDetailsRes?.asset?.lastState ?? "-"}
                  </Col>
                </Row>
                {assetDetailsRes?.lastAssociatedBol?.referenceId && (
                  <Row gutter={12} className="flex-grow items-center">
                    <Col span={8} className="font-medium">
                      BOL Number
                    </Col>
                    <Col span={16}>
                      <div
                        className="flex cursor-pointer items-center gap-2 text-blue-600"
                        onClick={async () => {
                          if (
                            downLoadingId ===
                            assetDetailsRes?.lastAssociatedBol?._id
                          ) {
                            return;
                          }
                          const bolId = assetDetailsRes?.lastAssociatedBol?._id;
                          setDownLoadingId(bolId);
                          await downloadBolPdf({ bolId });
                          setDownLoadingId(undefined);
                        }}
                      >
                        {/* <Button
                          onClick={async () => {
                            const bolId =
                              assetDetailsRes?.lastAssociatedBol?._id;
                            setDownLoadingId(bolId);
                            await downloadBolPdf({ bolId });
                            setDownLoadingId(undefined);
                          }}
                          type="primary"
                          icon={<PrinterOutlined />}
                          loading={
                            downLoadingId ===
                            assetDetailsRes?.lastAssociatedBol?._id
                          }
                          className="flex-shrink-0"
                        ></Button> */}
                        {downLoadingId ===
                        assetDetailsRes?.lastAssociatedBol?._id
                          ? "downloading..."
                          : assetDetailsRes?.lastAssociatedBol?.referenceId}
                      </div>
                    </Col>
                  </Row>
                )}
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    Customer
                  </Col>
                  <Col span={16}>
                    {assetDetailsRes?.lastAssociatedBol?.order?.customer
                      ?.name ?? "-"}
                  </Col>
                </Row>
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    Last Update
                  </Col>
                  <Col span={16}>
                    {dayjs(
                      assetDetailsRes?.lastAssetEvents?.[0]?.updatedAt,
                    ).format(DATE_TIME_FORMAT) ?? "-"}
                  </Col>
                </Row>
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    Product
                  </Col>
                  <Col span={16}>
                    {assetDetailsRes?.asset?.product?.name ?? "-"}
                  </Col>
                </Row>
                <Row gutter={12} className="flex-grow">
                  <Col span={8} className="font-medium">
                    Tag Name
                  </Col>
                  <Col span={16}>
                    {assetDetailsRes?.asset?.tag?.name ?? "-"}
                  </Col>
                </Row>
              </Flex>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchTagPage;
